interface Props {
  /** true 이면 신규 등록 모드 — 삭제 버튼 숨김, 저장 버튼이 오른쪽 끝 정렬 */
  isNew: boolean;
  /** true 이면 편집 모드 — 저장/취소 버튼 표시. false 이면 수정하기 버튼만 표시 */
  isEditing: boolean;
  /** true 이면 저장 버튼을 로딩 스피너로 대체하고 비활성화 */
  isSaving: boolean;
  /** 저장 버튼 라벨. 미지정 시 isNew ? '등록하기' : '저장하기' */
  saveLabel?: string;
  onEdit: () => void;
  onSave: () => void;
  onCancelEdit: () => void;
  /** 미지정 시 삭제 버튼을 렌더링하지 않음 */
  onDelete?: () => void;
  /** 삭제 버튼 라벨. 기본값: '삭제' */
  deleteLabel?: string;
}

/**
 * 상세 페이지 하단 액션 버튼 영역 (삭제 / 수정하기 / 취소 / 저장하기).
 * AdverDetail·NoticeDetail·MemberDetail 세 곳에서 동일한 패턴이 반복됐기 때문에 추출.
 */
export default function DetailActionButtons({
  isNew,
  isEditing,
  isSaving,
  saveLabel,
  onEdit,
  onSave,
  onCancelEdit,
  onDelete,
  deleteLabel = '삭제',
}: Props) {
  const submitLabel = saveLabel ?? (isNew ? '등록하기' : '저장하기');

  return (
    <div className="mt-8 flex justify-between items-center pt-6 border-t border-gray-200">
      {/* 신규 등록 모드에서는 삭제 버튼 노출 안 함 */}
      {!isNew && onDelete && (
        <button
          onClick={onDelete}
          className="px-6 py-3 bg-text-red text-white rounded-lg hover:bg-text-red/90 transition-colors flex items-center space-x-2 shadow-md"
        >
          <i className="fas fa-trash-alt"></i>
          <span>{deleteLabel}</span>
        </button>
      )}

      {/* 신규 등록 모드일 때는 버튼 묶음을 오른쪽 끝으로 밀어냄 */}
      <div className={`flex space-x-3 ${isNew ? 'ml-auto' : ''}`}>
        {!isEditing ? (
          <button
            onClick={onEdit}
            className="px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-all flex items-center space-x-2 shadow-md"
          >
            <i className="fas fa-edit"></i>
            <span>수정하기</span>
          </button>
        ) : (
          <>
            {/* 신규 등록 모드에서는 취소 버튼 없음 — 뒤로가기로 이탈 */}
            {!isNew && (
              <button
                onClick={onCancelEdit}
                className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors flex items-center space-x-2"
              >
                <i className="fas fa-times"></i>
                <span>취소</span>
              </button>
            )}
            <button
              onClick={onSave}
              disabled={isSaving}
              className={`px-6 py-3 bg-primary text-white rounded-lg transition-all flex items-center space-x-2 shadow-md ${
                isSaving ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'hover:bg-primary/90'
              }`}
            >
              {isSaving ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>저장 중...</span>
                </>
              ) : (
                <>
                  <i className="fas fa-save"></i>
                  <span>{submitLabel}</span>
                </>
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
